import { Super } from './super.model';

export class DisciplinaryTeam extends Super<DisciplinaryTeam>{

    public name: string;
    public users: any[];
}